import { KTIcon, KTSVG } from '../../../../_metronic/helpers'
import { Form } from 'react-bootstrap';
import { useMutation, useQuery } from 'react-query';
import { add_organisation_user, delete_organisation_user, get_organisation_users, update_organisation_user, verify_user } from '../api/OrganisationsApi';
import { toast } from 'react-toastify';
import { ChangeEvent, useEffect, useState } from 'react';
import { OrganisationListInterface, OrganisationUsersInterface } from '../../../modules/accounts/components/settings/SettingsModel';
import { useLocation, useNavigate } from 'react-router-dom';
import "../../../../_metronic/assets/keenicons/duotone/style.css";
import { validateImage } from '../../../helper_functions/ImageValidation';
function OrganisationUsers() {
    const [organistionUsers, setOrganisationUsers] = useState<OrganisationUsersInterface[]>([])
    const [selectedOganistionUser, setSelectedOrganisationUser] = useState<OrganisationUsersInterface>()
    const [searchInput, setSearchInput] = useState('');
    const [emailvalue, setEmailValue] = useState('')
    const [emailError, setEmailError] = useState('')
    const [firstNameValue, setFirstNameValue] = useState('')
    const [firstNameError, setFirstNameError] = useState('')
    const [lastNameError, setLastNameError] = useState('')
    const [middleNameValue, setMiddleNameValue] = useState('')
    const [lastNameValue, setLastNameValue] = useState('')
    const [isEditable, setIsEditable] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [mobileValue, setMobileValue] = useState('')
    const [userPicture, setUserPicture] = useState<File | null>(null);
    const [manageOrganisationValue, setManageOrganisationValue] = useState(0)
    const [manageApplicationValue, setManageApplicationValue] = useState(0)
    const location = useLocation();
    const organisation = (location.state as { organisation: OrganisationListInterface }).organisation
    const { data: usersData,isLoading, refetch } = useQuery(['get_organisation_users', organisation.id],
        () => get_organisation_users(organisation.id), {
        refetchOnWindowFocus: false
    }
    )
    const navigate = useNavigate();
    useEffect(() => {
        if (usersData) {
            setOrganisationUsers(usersData.data as OrganisationUsersInterface[])
        }
    }, [usersData])

    const verifyUserMutation = useMutation(verify_user, {
        onSuccess: (data: any) => {
            // Success: Set fetched data and show success toast
            setFirstNameValue(data.data.first_name);
            setMiddleNameValue(data.data.middle_name);
            setLastNameValue(data.data.last_name);
            setMobileValue(data.data.mobile_no);
            setUserPicture(data.data.profile_picture);
            toast.success(data?.message || 'Organisation added successfully!', {
                position: 'top-right',
                autoClose: 3000,
            });
        }, onError: (error: any) => {
            // Error: Show error toast
            const errorMessage =
                error?.response?.data?.message || error?.message || 'Something went wrong';
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 3000,
            });
        },
    });
    const resetForm = () => {
        setEmailValue('');
        setEmailError("")
        setFirstNameError("");
        setLastNameError("");
        setFirstNameValue('');
        setMiddleNameValue('');
        setLastNameValue('');
        setMobileValue('');
        setUserPicture(null);
        setManageOrganisationValue(0);
        setManageApplicationValue(0);
    };
    const handleAddOrganisationUser = useMutation(add_organisation_user, {
        onSuccess: (data: any) => {
            // Success: Show success toast and refetch data
            toast.success(data.message, {
                position: 'top-right',
                autoClose: 3000,
            });
            refetch();
        },
        onError: (error: any) => {
            // Error: Show error toast
            const errorMessage =
                error?.response?.data?.message || error?.message || 'Something went wrong';
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 3000,
            });
        },
    });

    const handleEditOrganisationUser = useMutation((Data: any) => update_organisation_user(Data.user_id, Data), {
        onSuccess: (response: any) => {
            refetch();
            if (usersData) {
                setOrganisationUsers(usersData.data as OrganisationUsersInterface[])
            }
            toast.success(response.message, {
                position: 'top-right',
                autoClose: 3000,
            });
        },
        onError: (error: any) => {
            if (error.response) {
                toast.error(error.response.data.message, {
                    position: "top-right",
                    autoClose: 3000,
                });
            } else if (error.request) {
                // The request was made but no response was received
                toast.error('No response received from the server.', {
                    position: "top-right",
                    autoClose: 3000,
                });
            } else {
                toast.error('An unexpected error occurred.', {
                    position: "top-right",
                    autoClose: 3000,
                });
            }
        },
    });
    const handleDeleteOrganisationUser = useMutation(delete_organisation_user, {
        onSettled: (data, error: any) => {
            if (!error) {
                refetch()
                toast.success(data.message, {
                    position: 'top-right',
                    autoClose: 3000,
                })
            } else {
                const errorMessage = error?.response?.data?.message || error?.message || 'Something went wrong';
                toast.error(errorMessage, {
                    position: 'top-right',
                    autoClose: 3000,
                })
            }
        },
    })
    const handleInputChange = (e: React.FormEvent<HTMLInputElement>) => {
        const searchTerm = e.currentTarget.value;
        setSearchInput(searchTerm);
        const filteredItems = usersData.data.filter((users) => {
            return (users.user.first_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            users.user.middle_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            users.user.last_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                users.user.email?.toLowerCase().includes(searchTerm.toLowerCase())
            )

        })

        setOrganisationUsers(filteredItems);
    };
      const handleImageChange = (
          e: React.ChangeEvent<HTMLInputElement>,
          logoType: string,
          MAX_FILE_SIZE: number,
          ALLOWED_TYPES: string[],
          MAX_DIMENSIONS: { [key: string]: { width: number; height: number } }
        ) => {
          const newFile = e.target.files?.[0];
          if (newFile) {
            // Call the validation function
            validateImage(
              newFile,
              logoType,
              (validFileUrl) => {
                // If valid, update the state with the image URL
                if (logoType === 'picture') {
                  setUserPicture(newFile);
                }
              },
              MAX_FILE_SIZE, // File size limit in MB
              ALLOWED_TYPES, // Allowed file types
              MAX_DIMENSIONS // Maximum dimensions per logo type
            );
          }
        };
    const handleButtonClick = () => {
        if (!emailvalue) {
            setEmailError('Email is required!');
            return;
        }
        setEmailError(''); // Clear the error message if email is valid
        verifyUserMutation.mutate({ email: emailvalue });
        setIsEditable(true); // Enable fields after data fetch.
    };
    if (isLoading) {
        return (
            <div className='text-center'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        );
      }
    return (
        <>
            <div className='card card-xxl-stretch mx-4 mb-5 mb-xl-10' style={{ position: 'relative' }}>
                <div className=''>
                    <div className='card-header border-0 pt-5'>
                        <h3 className='card-title d-flex justify-content-left'>
                            <KTIcon iconName='magnifier' className='fs-1 position-absolute mx-6' />
                            <input
                                data-toggle="tooltip"
                                data-placement="bottom"
                                title="Search a User"
                                type='text'
                                data-kt-user-table-filter='search'
                                className='form-control form-control-solid w-400px ps-14'
                                placeholder='Search a User'
                                value={searchInput}
                                onChange={handleInputChange}
                            />
                        </h3>
                        <div className='d-flex align-items-center'>
                            <div
                                className='card-toolbar'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                            >
                                <button
                                    data-toggle="tooltip" data-placement="bottom" title="Navigate to List of Organisation"
                                    className='btn btn-sm btn-light-dark m-3'
                                    onClick={() => navigate('/organisations')}
                                >
                                    Back to Organisations List
                                </button>
                            </div>
                            <button
                                data-toggle="tooltip" data-placement="bottom" title="Navigate to Add Organisation User"
                                className='btn btn-sm btn-light-dark m-3'
                                data-bs-toggle='modal'
                                data-bs-target='#kt_modal_2'
                                onClick={() => {
                                    resetForm();
                                    setIsEditable(false);
                                }}
                            >
                                Add Organisation User
                            </button>
                        </div>
                    </div>
                </div>
                {/* User listing */}
                <div className='card-body mt-3'>
                    <h3 className='mb-3'>Users to Manage Organisation</h3>
                    <table className='table align-middle table-row-dashed fs-6 gy-5'>
                        <thead className='bg-dark'>
                            <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0 '>
                                <th className='max-w-125px px-4'>Name</th>
                                <th className='max-w-200px'>Email</th>
                                <th className='max-w-200px'>Manage Organisation</th>
                                <th className='max-w-250px'>Manage Applications</th>
                                <th className='max-w-150px'>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {Array.isArray(organistionUsers) && organistionUsers.length > 0 ? (
                                organistionUsers.map((organistionUser) => (
                                <tr key={organistionUser.id}>
                                        <td className='px-4'>
                                            {`${organistionUser.user.first_name} ${organistionUser.user.middle_name ? organistionUser.user.middle_name + ' ' : ''}${organistionUser.user.last_name}`}
                                        </td>
                                        <td className='px-4'>{organistionUser.user.email}</td>
                                    <td className='px-4'>{organistionUser.can_manage_organization === 1 ? 'Yes' : 'No'}</td>
                                    <td className='px-4'>{organistionUser.can_manage_application === 1 ? 'Yes' : 'No'}</td>
                                    <td className='px-4'>
                                        <button
                                            data-toggle="tooltip" data-placement="bottom" title="Edit Organisation"
                                            className='btn btn-icon btn-light-dark btn-active-color-success btn-sm me-2'
                                            data-bs-toggle='modal'
                                            data-bs-target='#kt_modal_4'
                                            onClick={() =>{
                                                setFirstNameError("");
                                                setLastNameError("");
                                                setSelectedOrganisationUser({ ...organistionUser });
                                            }}
                                        >
                                            <KTIcon iconName='pencil' className='fs-3' />
                                        </button>
                                        {/* <button
                                            data-toggle="tooltip" data-placement="bottom" title="Delete Organisation User"
                                            className='btn btn-icon btn-light-dark btn-active-color-success btn-sm me-2'
                                            data-bs-toggle='modal'
                                            data-bs-target='#kt_modal_1'
                                            onClick={() => setSelectedOrganisationUser(organisationUser)}
                                        >
                                            <KTIcon iconName='trash' className='fs-3' />
                                        </button> */}
                                        <button
                                            data-toggle="tooltip" data-placement="bottom" title="View Organisation"
                                            className='btn btn-icon btn-light-dark btn-active-color-success btn-sm me-2'
                                            data-bs-toggle='modal'
                                            data-bs-target='#kt_modal_3'
                                            onClick={() => setSelectedOrganisationUser(organistionUser)}
                                        >
                                            <KTIcon iconName='eye' className='fs-3' />
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td className="text-muted">No organisation users found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {/* Add User */}
            <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
                <div className='modal-dialog modal-dialog-centered modal-lg'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Add Organisation User</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-dark ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr061.svg'
                                    className='svg-icon svg-icon-2x'
                                />
                            </div>
                        </div>
                        <div className='modal-body'>
                            <>
                                {/* ... Edit Form ... */}
                                <Form>
                                    <div className='form-group'>
                                        <div className='row mb-6'>
                                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                                Email
                                            </label>
                                            <div className='col-lg-6 fv-row'>
                                                <input
                                                    type='email'
                                                    value={emailvalue}
                                                    className='form-control form-control-lg form-control-solid user-input'
                                                    placeholder='Write Email Address'
                                                    onChange={(e) => { setEmailValue(e.target.value) }}
                                                />
                                                {emailError && <div className="text-danger mt-2">{emailError}</div>}
                                            </div>
                                            <div className='col-lg-2 mt-2'>
                                                <button type='button' className='btn btn-sm btn-dark user-input'
                                                 onClick={handleButtonClick}
                                                >
                                                Fetch Data
                                            </button>
                                        </div>
                                        </div>
                                        <div className='row mb-6'>
                                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                                First Name
                                            </label>
                                            <div className='col-lg-8 fv-row'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-lg form-control-solid user-input'
                                                    placeholder='Write First Name'
                                                    value={firstNameValue}
                                                    onChange={(e) =>{ 
                                                        if (!e.target.value) {
                                                            setFirstNameError('First Name is Required.')
                                                          } else {
                                                            setFirstNameError('')
                                                          }
                                                        setFirstNameValue(e.target.value)}}
                                                    readOnly={!isEditable}
                                                />
                                              {firstNameError && (
                                        <div className='text-danger'>{firstNameError}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='row mb-6'>
                                            <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                                Middle Name
                                            </label>
                                            <div className='col-lg-8 fv-row'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-lg form-control-solid user-input'
                                                    placeholder='Write Middle Name'
                                                    value={middleNameValue}
                                                    onChange={(e) => setMiddleNameValue(e.target.value)}
                                                    readOnly={!isEditable}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mb-6'>
                                            <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                                Last Name
                                            </label>
                                            <div className='col-lg-8 fv-row'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-lg form-control-solid user-input'
                                                    placeholder='Write Last Name'
                                                    value={lastNameValue}
                                                    onChange={(e) => {
                                                        if (!e.target.value) {
                                                            setLastNameError('Last Name is Required.')
                                                        } else {
                                                            setLastNameError('')
                                                        }
                                                        setLastNameValue(e.target.value)
                                                    }}
                                                    readOnly={!isEditable}
                                                />
                                                {lastNameError && (
                                                    <div className='text-danger'>{lastNameError}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className='row mb-6'>
                                            <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                                Mobile Number
                                            </label>
                                            <div className='col-lg-8 fv-row'>
                                                <input
                                                    type='number'
                                                    className='form-control form-control-lg form-control-solid user-input'
                                                    placeholder='Write Mobile Number'
                                                    value={mobileValue}
                                                    readOnly={!isEditable}
                                                    onChange={(e) => setMobileValue(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className='row mb-6'>
                                            <label className='col-lg-4 col-form-label fw-bold fs-6'>Picture</label>
                                            <div className='col-lg-8 fv-row'>
                                                <input
                                                    type='file'
                                                    className='form-control form-control-lg form-control-solid'
                                                    onChange={(e) => handleImageChange(
                                                        e,
                                                        'picture',
                                                        2, // Max file size (2MB)
                                                        ['image/jpeg', 'image/jpg', 'image/png'], // Allowed types
                                                        {
                                                          picture: { width: 200, height: 200 }
                                                        } // Max dimensions
                                                      )}
                                                      accept="image/jpeg, image/jpg, image/png"
                                                    name='picture'
                                                />
                                                <div className='text-danger mt-2'>
                                                    Recommended size: 200 x 200 px, max file size: 2MB, and accepted file types: jpg, jpeg, or png only.
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mb-6'>
                                            <div className='col-lg-4'>
                                            <label className='col-lg-4 col-form-label fw-bold fs-6'>Permissions</label>
                                            </div>
                                            <div className='col-lg-8'>
                                                <div className="form-check form-check-custom form-check-solid form-check-sm col-lg-12 mb-6">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value={manageOrganisationValue}
                                                        id="flexRadioLg"
                                                        checked={manageOrganisationValue === 1}
                                                        onChange={() => setManageOrganisationValue(manageOrganisationValue === 1 ? 0 : 1)}
                                                    />
                                                    <label className="form-check-label text-dark" htmlFor="flexRadioLg">
                                                        Manage Organisations
                                                    </label>
                                                </div>
                                                <div className="form-check form-check-custom form-check-solid form-check-sm col-lg-12 mb-6">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value={manageApplicationValue}
                                                        id="flexRadioLg"
                                                        checked={manageApplicationValue === 1}
                                                        onChange={() => setManageApplicationValue(manageApplicationValue === 1 ? 0 : 1)}
                                                    />
                                                    <label className="form-check-label text-dark" htmlFor="flexRadioLg">
                                                        Manage Applications
                                                    </label>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </>
                        </div>

                        <div className='modal-footer p-0'>
                            <div className='card-footer d-flex justify-content-end py-6 px-4 '>
                            {firstNameError || lastNameError || emailError ? (
                            <button type='button' data-toggle="tooltip" data-placement="bottom" title="Add Organisation User" className='btn btn-primary disabled'>
                                Add Organisation User
                            </button>
                        ) : (
                                <button
                                    data-toggle="tooltip" data-placement="bottom" title="Add Organisation User"
                                    type='button'
                                    className={`btn btn-dark`}
                                    data-bs-dismiss='modal'
                                    onClick={() => {
                                        handleAddOrganisationUser.mutate({
                                            email: emailvalue,
                                            first_name: firstNameValue,
                                            middle_name: middleNameValue,
                                            last_name: lastNameValue,
                                            mobile_no: mobileValue,
                                            profile_picture: userPicture,
                                            organization_id: organisation?.id,
                                            can_manage_organization: manageOrganisationValue,
                                            can_manage_application: manageApplicationValue,
                                        })
                                    }}
                                >
                               Add Organisation User

                                </button>
                        )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Delete modal */}
            {/* <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
                <div className='modal-dialog'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Delete Organisation User Confirmation</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr061.svg'
                                    className='svg-icon svg-icon-2x'
                                />
                            </div>
                        </div>
                        <div className='modal-body'>
                            {selectedOganistionUser ? (
                                <>
                                    <p className='mb-2'>
                                        <span className='fw-bold'>Full Name: </span> {selectedOganistionUser.user.first_name + " " + selectedOganistionUser.user.last_name}
                                    </p>
                                    <p className='mb-2'>
                                        <span className='fw-bold'>Emails: </span>{' '}
                                        {selectedOganistionUser.user.email}
                                    </p>
                                </>
                            ) : null}
                        </div>
                        <div className='modal-footer'>
                            <button data-toggle="tooltip" data-placement="bottom" title="close" type='button' className='btn btn-light' data-bs-dismiss='modal'>
                                Close
                            </button>
                            <button
                                data-toggle="tooltip" data-placement="bottom" title="Delete this Organisation"
                                type='button'
                                onClick={() => {
                                    if (selectedOganistionUser && selectedOganistionUser.user_id && selectedOganistionUser.organization_id) {
                                        handleDeleteOrganisationUser.mutate({
                                            user_id: selectedOganistionUser.user_id,
                                            organization_id: selectedOganistionUser.organization_id,
                                        })
                                    }
                                }}
                                className='btn btn-danger'
                                data-bs-dismiss='modal'
                            >
                                Delete Organisation
                            </button>
                        </div>
                    </div>
                </div>
            </div> */}
<div className="modal fade" tabIndex={-1} id="kt_modal_3">
    <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title fs-3">View Organisation User</h5>
                <button
                    type="button"
                    className="btn btn-icon btn-lg btn-active-light-primary"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                >
                    <KTSVG
                        path="/media/icons/duotune/arrows/arr061.svg"
                        className="svg-icon svg-icon-3x"
                    />
                </button>
            </div>
            <div className="modal-body px-4">
                {selectedOganistionUser ? (
                    <div className="row">
                        {/* Profile Picture */}
                        <div className="col-12 col-md-4 text-center mb-4 mb-md-0">
                            {selectedOganistionUser.user.profile_picture ? (
                                <img
                                    src={selectedOganistionUser.user.profile_picture}
                                    className="img-fluid edit-organisation-img rounded"
                                    alt="Profile"
                                />
                            ) : (
                                <div className="symbol symbol-circle symbol-150px">
                                    <div className="symbol-label fs-1 fw-bold text-inverse-dark bg-dark">
                                        {selectedOganistionUser.user.first_name ? selectedOganistionUser.user.first_name[0].toUpperCase() : ''}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* User Details */}
                        <div className="col-12 col-md-8">
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">Email:</label>
                                <div className="col-7 fs-3">{selectedOganistionUser.user.email}</div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">First Name:</label>
                                <div className="col-7 fs-3">{selectedOganistionUser.user.first_name}</div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">Middle Name:</label>
                                <div className="col-7 fs-3">
                                    {selectedOganistionUser.user.middle_name || 'N/A'}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">Last Name:</label>
                                <div className="col-7 fs-3">{selectedOganistionUser.user.last_name}</div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">Mobile No:</label>
                                <div className="col-7 fs-3">
                                    {selectedOganistionUser.user.mobile_no || 'N/A'}
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-5 fw-bold fs-3">Permissions:</label>
                                <div className="col-7 fs-3">
                                    <div>
                                        {selectedOganistionUser.can_manage_organization === 1
                                            ? 'Can Manage Organisation'
                                            : 'Can Not Manage Organisation'}
                                    </div>
                                    <div>
                                        {selectedOganistionUser.can_manage_application === 1
                                            ? 'Can Manage Applications'
                                            : 'Can Not Manage Applications'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="fs-3 text-center">No User Data Available</div>
                )}
            </div>
        </div>
    </div>
</div>

            {/* Edit User */}
            <div className='modal fade' tabIndex={-1} id='kt_modal_4'>
                <div className='modal-dialog modal-dialog-centered modal-lg'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Edit Organisation User</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-dark ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr061.svg'
                                    className='svg-icon svg-icon-2x'
                                />
                            </div>
                        </div>
                        <div className='modal-body'>
                            {selectedOganistionUser ? (
                                <>
                                    {/* ... Edit Form ... */}
                                    <Form>
                                        <div className='form-group'>
                                            <div className='row mb-6'>
                                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                                    Email
                                                </label>
                                                <div className='col-lg-8 fv-row'>
                                                    <label className='form-control form-control-lg form-control-solid user-input' >{selectedOganistionUser?.user?.email}</label>
                                                </div>
                                                {/* <div className='col-lg-2 mt-2'>
                                                    <button type='button' className='btn btn-sm btn-dark user-input'
                                                        onClick={() => {
                                                            verifyUserMutation.mutate({
                                                                email: emailvalue
                                                            })
                                                        }}
                                                    >
                                                        Fetch Data
                                                    </button>
                                                </div> */}
                                            </div>
                                            <div className='row mb-6'>
                                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                                    First Name
                                                </label>
                                                <div className='col-lg-8 fv-row'>
                                                    <input
                                                        type='text'
                                                        className='form-control form-control-lg form-control-solid user-input'
                                                        placeholder='Write First Name'
                                                        value={selectedOganistionUser ? selectedOganistionUser.user.first_name : ''}
                                                        onChange={(e) => {
                                                            if (!e.target.value) {
                                                                setFirstNameError('First Name is Required.')
                                                            } else {
                                                                setFirstNameError('')
                                                            }
                                                            setSelectedOrganisationUser({
                                                                ...selectedOganistionUser,
                                                                user: {
                                                                    ...selectedOganistionUser.user,
                                                                    first_name: e.target.value,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                    {firstNameError && (
                                            <div className='text-danger'>{firstNameError}</div>
                                        )}
                                                </div>

                                            </div>
                                            <div className='row mb-6'>
                                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                                    Middle Name
                                                </label>
                                                <div className='col-lg-8 fv-row'>
                                                    <input
                                                        type='text'
                                                        className='form-control form-control-lg form-control-solid user-input'
                                                        placeholder='Write Middle Name'
                                                        value={selectedOganistionUser.user.middle_name || ''}
                                                        onChange={(e) => {
                                                            setSelectedOrganisationUser({
                                                                ...selectedOganistionUser,
                                                                user: {
                                                                    ...selectedOganistionUser.user,
                                                                    middle_name: e.target.value,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className='row mb-6'>
                                                <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                                                    Last Name
                                                </label>
                                                <div className='col-lg-8 fv-row'>
                                                    <input
                                                        type='text'
                                                        className='form-control form-control-lg form-control-solid user-input'
                                                        placeholder='Write Last Name'
                                                        value={selectedOganistionUser ? selectedOganistionUser.user.last_name : ''}
                                                        onChange={(e) => {
                                                            if (!e.target.value) {
                                                                setLastNameError('Last Name is Required.')
                                                            } else {
                                                                setLastNameError('')
                                                            }
                                                            setSelectedOrganisationUser({
                                                                ...selectedOganistionUser,
                                                                user: {
                                                                    ...selectedOganistionUser.user,
                                                                    last_name: e.target.value,
                                                                },
                                                            });
                                                        }}
                                                    />
                                                              {lastNameError && (
                                            <div className='text-danger'>{lastNameError}</div>
                                        )}
                                                </div>
                                            </div>
                                            <div className='row mb-6'>
                                                <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                                    Mobile Number
                                                </label>
                                                <div className='col-lg-8 fv-row'>
                                                    <input
                                                        type='number'
                                                        className='form-control form-control-lg form-control-solid user-input'
                                                        placeholder='Write Mobile Number'
                                                        value={selectedOganistionUser?.user.mobile_no || ''} 
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            setSelectedOrganisationUser((prevState) => {
                                                              if (!prevState) return prevState;  // Ensure prevState is not undefined
                                                              return {
                                                                ...prevState,
                                                                user: {
                                                                  ...prevState.user,
                                                                  mobile_no: value,
                                                                },
                                                              };
                                                            });
                                                          }}                                                                                                                
                                                    />
                                                </div>
                                            </div>
                                            <div className='row mb-6'>
                                                <label className='col-lg-4 col-form-label fw-bold fs-6'>Picture</label>
                                                <div className='col-lg-8 fv-row'>
                                                    <input
                                                        type='file'
                                                        className='form-control form-control-lg form-control-solid'
                                                        onChange={(e) => handleImageChange(
                                                            e,
                                                            'picture',
                                                            2, // Max file size (2MB)
                                                            ['image/jpeg', 'image/jpg', 'image/png'], // Allowed types
                                                            {
                                                              picture: { width: 200, height: 200 }
                                                            } // Max dimensions
                                                          )}
                                                          accept="image/jpeg, image/jpg, image/png"
                                                        name='picture'
                                                    />
                                                    <div className='text-danger mt-2'>
                                                        Recommended size: 200 x 200 px, max file size: 2MB, and accepted file types: jpg, jpeg, or png only.
                                                    </div>
                                                    {
                                                selectedOganistionUser.user.profile_picture ? (
                                                    <div className='mt-3'>
                                                    <img src={selectedOganistionUser ? selectedOganistionUser.user.profile_picture : ''} className="img-fluid img-thumbnail" width={200} height={200} alt="No Image Found" />
                                                </div>
                                                ):(
                                                    <div className='mt-3 text-muted'>No existing image</div>
                                                )
                                            }
                                                </div>
                                            </div>
                                            <div className='row mb-6'>
                                            <div className='col-lg-4'>
                                            <label className='col-lg-4 col-form-label fw-bold fs-6'>Permissions</label>
                                            </div>
                                                <div className='col-lg-8'>
                                                    <div className="form-check form-check-custom form-check-solid form-check-sm col-lg-12 mb-6">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="manageOrganization"
                                                            checked={selectedOganistionUser?.can_manage_organization === 1} // Check for value '1'
                                                            onChange={() => {
                                                                setSelectedOrganisationUser({
                                                                    ...selectedOganistionUser,
                                                                    can_manage_organization:
                                                                        selectedOganistionUser.can_manage_organization === 1 ? 0 : 1, // Toggle between '1' and '0'
                                                                });
                                                            }}
                                                        />
                                                        <label className="form-check-label text-dark" htmlFor="manageOrganization">
                                                            Manage Organisations
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-check-custom form-check-solid form-check-sm col-lg-12 mb-6">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="manageApplication"
                                                            checked={selectedOganistionUser?.can_manage_application === 1} // Check for value '1'
                                                            onChange={() => {
                                                                setSelectedOrganisationUser({
                                                                    ...selectedOganistionUser,
                                                                    can_manage_application:
                                                                        selectedOganistionUser.can_manage_application === 1 ? 0 : 1, // Toggle between '1' and '0'
                                                                });
                                                            }}
                                                        />
                                                        <label className="form-check-label text-dark" htmlFor="manageApplication">
                                                            Manage Applications
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </>
                            ) : null}
                        </div>

                        <div className='modal-footer p-0'>
                            <div className='card-footer d-flex justify-content-end py-6 px-4 '>
                            {firstNameError || lastNameError ? (
                            <button type='button' data-toggle="tooltip" data-placement="bottom" title="Update Organisation User" className='btn btn-primary disabled'>
                                Update Organisation User
                            </button>
                        ) : (
                                <button
                                    data-toggle="tooltip" data-placement="bottom" title="Update Organisation User"
                                    type='button'
                                    className={`btn btn-dark`}
                                    data-bs-dismiss='modal'
                                    onClick={() => {
                                        handleEditOrganisationUser.mutate({
                                            user_id: selectedOganistionUser?.user_id,
                                            // email: selectedOganistionUser?.user.email,
                                            first_name: selectedOganistionUser?.user.first_name,
                                            middle_name: selectedOganistionUser?.user.middle_name,
                                            last_name: selectedOganistionUser?.user.last_name,
                                            mobile_no: selectedOganistionUser?.user.mobile_no,
                                            organization_id: selectedOganistionUser?.organization_id,
                                            profile_picture: userPicture,
                                            can_manage_organization: selectedOganistionUser?.can_manage_organization,
                                            can_manage_application: selectedOganistionUser?.can_manage_application,
                                        })
                                    }}
                                >
                                Update Organisation User

                                </button>
                        )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default OrganisationUsers;
